module.exports = __webpack_public_path__ + "static/img/1.a2d35c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/9.8/1.png
// module id = UwTx
// module chunks = 0